import React, { useState } from "react";
import Typography from "@mui/material/Typography";
import CXAIFiltersDialog from "./CXAIFiltersDialog";
import CallTableViewModel from "../../../ViewModels/CallTableViewModel";
import FilterChipDisplay from "../../FilterChipDisplay";

interface IFiltersProps {
    callTableViewModel: CallTableViewModel
    setCallTableViewModel: (value: CallTableViewModel) => void
}

export default function CXAIFilters({ callTableViewModel, setCallTableViewModel }: IFiltersProps) {
    const [open, setOpen] = useState(false);

    const text =
        <Typography variant="body1">
            {
                "CX-AI - "
            }
            {
                (callTableViewModel.filters.cxaiFilters.question !== "") ?
                    callTableViewModel.filters.cxaiFilters.question + ' - ' + callTableViewModel.filters.cxaiFilters.answer
                    : ' Is Any'
            }
        </Typography>

    return (
        <>
            <FilterChipDisplay
                text={text}
                selectable
                onClick={() => setOpen(true)} />
            <CXAIFiltersDialog
                open={open}
                setOpen={setOpen}
                callTableViewModel={callTableViewModel}
                setCallTableViewModel={setCallTableViewModel}
            />
        </>
    )
}